const market = (state) => state;

const geo = (state) => state.geo;

export default {
    market,
    geo,
};
